import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgSlideUp({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 11.118l7.553 3.777a1 1 0 00.995-1.731l-.1-.058-8.042-4.02-.12-.044-.104-.025-.07-.01L12 9l-.11.006-.075.011-.063.014-.08.025-.075.03-8.044 4.02a1 1 0 00.787 1.835l.107-.046L12 11.118l7.553 3.777L12 11.118z"
        fill={color}
      />
    </svg>
  )
}

export default SvgSlideUp
